import getTransformedDeclension from '~/assets/services/helpers/getTransformedDeclension';

export default function getShowedVariantOfPriceUnit(qty, unit, conversionUnit = null) {
    const properUnit = conversionUnit || unit;
    return getTransformedDeclension(qty, properUnit, false);
}
